<template>
    <div class="de-flyline" ref="element">2</div>
</template>
<script>
import './flyLine.less';
import echarts from 'echarts';
import geoData from '../../../config/china.json';
import { option, convertData, planePath, geoCoordMap } from './option';
import { flyData } from './data';
import { COLORS } from '../../../config/color';

export default {
    data(){
        const chartsContainer = {
            chart: null,
            series: []
        }
        return {
            getFlyChart(){
                return chartsContainer;
            }
        }
    },
    props: {
        option: {
            type: Object,
            default(){
                return {
                    areaColor: '#063F7A',
                    borderColor: '#0A6FD5',
                    //图形
                    type: 'plane',
                    emphasis: {
                        areaColor: '#063F7A'
                    }
                }
            }
        }
    },
    mounted(){
        echarts.registerMap('china',geoData);
        this.mapChartSeries();
        this.initChart();
    },
    methods:{
        initChart(){
            const chartsContainer = this.getFlyChart();
            const { areaColor, borderColor } = this.option
            if(!chartsContainer.chart){
                chartsContainer.chart = echarts.init(this.$refs.element);  
                window.addEventListener("resize", chartsContainer.chart.resize); 
            }
            //更新props配置
            option.geo.itemStyle.normal = {
                areaColor: areaColor,
                borderColor: borderColor
            }
            option.geo.itemStyle.emphasis = {
                areaColor: areaColor
            }
            option.series = chartsContainer.series;
            chartsContainer.chart.setOption(option, true);
        },
        destroyedChart(){
            const chartsContainer = this.getFlyChart();
            if(chartsContainer.chart){
               window.removeEventListener("resize", chartsContainer.chart.resize, false); 
               chartsContainer.chart.dispose();
               chartsContainer.chart = null;
            }
            chartsContainer.series = [];
        },
        mapChartSeries(){
            const series = [];
            const chartsContainer = this.getFlyChart();
            const { type } = this.option;
            let flyType = type === 'plane' ? true : false
            flyData.forEach((it,index)=>{
                let child = it[0];
                if( child && child[0]  ){
                    let name = child[0].name;
                    series.push(
                        {
                            name: name,
                            type: 'lines',
                            zlevel: 1,
                            effect: {
                                show: true,
                                period: 6,
                                trailLength: 0.7,
                                color: '#fff',
                                symbolSize: 3
                            },
                            lineStyle: {
                                normal: {
                                    color: COLORS[index],
                                    width: 0,
                                    curveness: 0.2
                                }
                            },
                            data: convertData(it)
                        },
                        {
                            name: name,
                            type: 'lines',
                            zlevel: 2,
                            symbol: ['none'],
                            symbolSize: 10,
                            effect: {
                                show: flyType,
                                period: 6,
                                trailLength: 0,
                                symbol: planePath,
                                symbolSize: 15
                            },
                            lineStyle: {
                                normal: {
                                    color: COLORS[index],
                                    width: 1,
                                    opacity: 0.6,
                                    curveness: 0.2
                                }
                            },
                            data: convertData(it)
                        },
                        {
                            name: name,
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            zlevel: 2,
                            rippleEffect: {
                                brushType: 'stroke'
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'right',
                                    formatter: '{b}'
                                }
                            },
                            symbolSize: function (val) {
                                return val[2] / 8;
                            },
                            itemStyle: {
                                normal: {
                                    color: COLORS[index]
                                }
                            },
                            data: it.map(function (dataItem) {
                                return {
                                    name: dataItem[1].name,
                                    value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
                                };
                            })
                        }
                    ) 
                }
            })
            chartsContainer.series = series;
        }
    },
    destroyed(){
        this.destroyedChart();
    }
}
</script>